import { useEffect } from 'react';

const useScript = (url: string, async: boolean, onLoad?: (...args: unknown[]) => void): void => {
  useEffect(() => {
    // don't add if script already exists on the page
    if (
      Array.from(document.querySelectorAll('script')).some((script) => script.src.includes(url))
    ) {
      if (onLoad) onLoad();
      return;
    }

    const script = document.createElement('script');

    script.src = url;
    script.async = async;

    if (onLoad) script.addEventListener('load', onLoad);

    document.body.appendChild(script);
    // we only want this to run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useScript;
